<template lang="pug">
  form.form
    .form-group
      label {{$t('userAddressEditor.streetAndNum')}} 
      input.form-control(type="text", v-model='street') 
    .form-group
      label {{$t('userAddressEditor.pcAndCity')}}
      input.form-control(type="text", v-model='city') 
    .form-group
      label {{$t('userAddressEditor.country')}}
      input.form-control(type="text", v-model='country') 
    a.btn.btn-primary.btn-block(@click="saveUserAddress") {{btnText}}
</template>
<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

export default {
  props: {
    btnText: {
      type: String,
      required: false,
      default: Vue.i18n.t('globals.save')
    }
  },
  data () {
    return {
      street: '',
      city: '',
      country: ''
    }
  },
  computed: {
    ...mapGetters('user', [
      'user'
    ])
  },
  mounted () {
    this.setUserData()
  },
  methods: {
    saveUserAddress () {
      this.$store.dispatch('user/update', {
        address: {
          street: this.street,
          city: this.city,
          country: this.country
        }
      }).then(() => {
        this.$emit('saved')
      })
    },
    setUserData () {
      if (this.user && this.user.address) {
        this.street = this.user.address.street
        this.city = this.user.address.city
        this.country = this.user.address.country
      }
    }
  },
  watch: {
    'user.address': function () {
      this.setUserData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// UserAddressEdition.vue?92ae4f5a